import React, { useState } from "react";
import { CommonActions } from "@react-navigation/native";
import { View, StyleSheet, Animated } from "react-native";
import { widthPercentageToDP } from "react-native-responsive-screen";
import { useSelector } from "react-redux";
import { getTeamNotifications } from "@microdoing/shared/services/notification/selectors";
import TopTab from "./TopTab";
import theme from "app/Theme/Theme";

const styles = StyleSheet.create({
  main: {
    marginLeft: widthPercentageToDP("6%"),
    position: "relative",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    height: 40,
  },
  selector: {
    zIndex: 10,
    height: 2,
    position: "absolute",
    left: 0,
    bottom: 2,
    borderWidth: 1,
    borderColor: theme.colors["brand.500"],
    backgroundColor: theme.colors["brand.500"],
    borderRadius: 8,
  },
});

const TRANSLATE_X = 20;

const getTranslateOutputRange = widths => {
  return widths.reduce((prev, curr, index, array) => {
    let newSum = 0;
    if (index > 0) {
      newSum = prev[index - 1] + array[index - 1] + TRANSLATE_X;
    }
    if (index === 0) {
      newSum = 0;
    }
    prev.push(newSum);
    return prev;
  }, []);
};

const TopTabBar = args => {
  const { state, descriptors, navigation, position, preventDefault } = args;

  const teamNotifications = useSelector(getTeamNotifications);
  const [widthOutputRanges, setWidthOutputRanges] = useState([0, 1, 2]);

  const onTabPress = newTab => () => {
    const isFocused = state.routeNames[state.index] === newTab.name;
    const newTabName = newTab.name;

    const event = navigation.emit({
      type: "tabPress",
      target: newTab.key,
      canPreventDefault: true,
    });

    if (!isFocused && !event.defaultPrevented) {
      // The `merge: true` option makes sure that the params inside the tab screen are preserved
      // navigation.navigate({ name: newTab.name, merge: true });

      navigation.dispatch({
        ...CommonActions.navigate({
          name: newTabName,
          key: newTab.key,
        }),
      });
    }
  };

  const measureWidth = tabIndex => ({ nativeEvent }) => {
    setWidthOutputRanges(prev => {
      const newArray = [...prev];
      newArray[tabIndex] = nativeEvent.layout.width;

      return newArray;
    });
  };

  const width = position.interpolate({
    inputRange: [0, 1, 2],
    outputRange: widthOutputRanges,
  });

  const onLongPress = route => () => {
    navigation.emit({
      type: "tabLongPress",
      target: route.key,
    });
  };

  const inputRange = state.routes.map((_, i) => i);

  return (
    <View style={styles.main}>
      <Animated.View
        style={[
          styles.selector,
          { width: 35 },
          {
            transform: [
              {
                translateX: position.interpolate({
                  inputRange: [0, 1, 2],
                  outputRange: getTranslateOutputRange(widthOutputRanges),
                }),
              },
            ],
          },
        ]}
      />
      {state.routes.map((route, index) => {
        const { options } = descriptors[route.key];
        const label =
          options.tabBarLabel !== undefined
            ? options.tabBarLabel
            : options.title !== undefined
            ? options.title
            : route.name;

        const isFocused = state.index === index;

        const outputRange = inputRange.map(i => (i === index ? 1 : 0.3));

        const opacity = position.interpolate({
          inputRange,
          outputRange,
        });

        return (
          <TopTab
            {...route}
            testID={`top-tab-${index}`}
            hasNotification={index === 2 && teamNotifications?.length}
            measureWidth={measureWidth(index)}
            options={options}
            isFocused={isFocused}
            opacity={opacity}
            label={label}
            onPress={onTabPress(route)}
            onLongPress={onLongPress(route)}
          />
        );
      })}
    </View>
  );
};

export default React.memo(TopTabBar);
